// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__3j3Rs","buttons":"SendReceipts_buttons__3Ziq6","email":"SendReceipts_email__2MlPH","bookApptTitle":"SendReceipts_bookApptTitle__QXWxQ"};